
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * A hook that manages scroll position when navigating between pages
 * Prevents unwanted scrolling when clicking on links
 */
export function useScrollRestoration() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Scroll to top when navigating to a new page
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}
